import React from 'react'

import Row, { Slot } from './row'
import Button from './button'
import styles from '../component-styles/connect-analytics-blocker.module.scss'
import ConnectButton from './connect-button'

interface Props {
  billingNotSet: boolean
}

export default function ConnectAnalyticsBlocker({
  billingNotSet,
}: Props): React.ReactElement {
  return (
    <Row style={{ marginTop: '60px', marginBottom: '150px' }}>
      <Slot width={580} className={styles.moduleBox}>
        <h1 className={styles.title}>Get automated insights</h1>
        <p className={styles.par}>
          {billingNotSet ? (
            <>
              Please complete your setup journey by selecting your payment
              option.
            </>
          ) : (
            <>
              Connect to your analytics for automated campaign reports and KPI
              insights.
            </>
          )}
        </p>
        {billingNotSet ? (
          <Button
            className={styles.centerButton}
            href="/plans"
            style={{ maxWidth: '200px' }}
          >
            Select payment option
          </Button>
        ) : (
          <>
            <ConnectButton />
            <ConnectButton adobe />
          </>
        )}
      </Slot>
    </Row>
  )
}
